"use strict";var e=require("styled-components"),t=require("./utils-DjLgVU1p.js");function i(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var o=i(e);const a=e.keyframes`
    from {
        margin-top: -48px;
    }
    to {
        margin-top: -16px;
    }
`,n=e.keyframes`
    from {
        margin-top: -16px;
    }
    to {
        margin-top: -48px;
    }
`,r=e.keyframes`
    0% {
        margin-left: 0px;
    }
    25% {
        margin-left: -4px;
    }
    50% {
        margin-left: 4px;
    }
    75% {
        margin-left: -2px;
    }
    100% {
        margin-left: 0px;
    }
`,s=e.css`
    animation: 200ms ${r} linear;
`,d=e.css`
    animation: ${a} 200ms cubic-bezier(1, 0.5, 0, 0.5);
`,l=e.css`
    animation: ${n} 80ms cubic-bezier(1, 0, 1, 1);
`,p=o.default.div`
    width: 100%;
    position: relative;
    ${({showError:e})=>e&&s}
    ${({disabled:e})=>e&&"pointer-events: none;"}
`,m=o.default.input((({theme:e,leftActionWidth:i,rightSideWidth:o,showError:a,disabled:n,isError:r})=>{const{colorMode:s}=e;return Object.assign(Object.assign({width:"100%",padding:e.spacing.medium,height:"56px",paddingRight:`${16+o}px`,paddingLeft:`calc(16px + ${e.spacing.xxSmall} + ${i}px)`,border:`1.5px solid ${t.getTextFieldThemeColor(e,n,a)}`,color:t.getTextColor(e,n),background:n&&!r?"transparent":e.colors[s].background_Primary,boxSizing:"border-box",appearance:"none",outline:"none",borderRadius:e.cornerRadius.medium,transition:"border-color 0.3s ease",textOverflow:"ellipsis"},e.typography["V2.body1.neutral.medium"]),{"&:focus":{borderColor:t.getTextFieldThemeColor(e,n,a,!0),caretColor:t.getTextFieldThemeColor(e,n,a,!0),boxShadow:"0px 8px 16px rgba(27, 30, 36, 0.1)"},"&:focus + label":Object.assign({top:`-${e.spacing.xSmall}`,left:e.spacing.medium,color:t.getPlaceHolderTextColor(e,n,a,!0)},e.typography["V2.body3.neutral.medium"]),"&:-webkit-outer-spin-button":{WebkitAppearance:"none",MozAppearance:"textfield",appearance:"none",margin:0},"&:-webkit-autofill, &:-webkit-autofill:focus, &:-webkit-autofill:hover":{boxShadow:"0 0 0 40rem #fff inset"},"&:in-range::-webkit-datetime-edit-year-field, &:in-range::-webkit-datetime-edit-month-field, &:in-range::-webkit-datetime-edit-day-field,&:in-range::-webkit-datetime-edit-text":{display:"none"},"&:in-range::-webkit-calendar-picker-indicator":{backgroundImage:"none",width:"100%"},"&::-webkit-date-and-time-value":{textAlign:"inherit"}})})),c=o.default.label((({theme:e,showError:i,labelActive:o,disabled:a,focused:n})=>{const{colorMode:r}=e;return Object.assign({position:"absolute",width:"fit-content",top:o?`-${e.spacing.xSmall}`:e.spacing.medium,left:e.spacing.medium,right:o?e.spacing.xxLarge:e.spacing.medium,padding:`${e.spacing.xxxSmall} ${e.spacing.xxSmall}`,overflow:"hidden",pointerEvents:"none",textOverflow:"ellipsis",color:t.getPlaceHolderTextColor(e,a,i,n),background:!o&&a?"transparent":e.colors[r].background_Primary,transition:"top 0.1s ease, left 0.1s ease, color 0.1s ease, font-size 0.1s ease",display:"-webkit-box",wordWrap:"break-word","-webkit-line-clamp":"1","-webkit-box-orient":"vertical"},o?e.typography["V2.body3.neutral.medium"]:e.typography["V2.body1.neutral.medium"])})),g=o.default.span((({theme:e,disabled:t,isTextField:i,inputLimit:o})=>Object.assign(Object.assign({position:"absolute",right:e.spacing.medium,top:e.spacing.medium,display:"flex",justifyContent:"space-evenly",alignItems:"center",pointerEvents:t?"none":void 0},i&&{top:"none",bottom:e.spacing.medium}),o&&{bottom:e.spacing.xxLarge}))),u=o.default.span`
    position: relative;
    z-index: -1;
    width: 100%;
    display: flex;
    border-radius: 0 0 ${({theme:e})=>e.cornerRadius.medium}
        ${({theme:e})=>e.cornerRadius.medium};
    background: ${({theme:e,showError:t})=>t?e.colors[e.colorMode].negative_Sub:e.colors[e.colorMode].background_Secondary};
    padding: ${({theme:e})=>e.spacing.xLarge} ${({theme:e})=>e.spacing.medium}
        ${({theme:e})=>e.spacing.xSmall};
    margin-top: -${({theme:e})=>e.spacing.medium};
    box-sizing: border-box;
    ${({showError:e})=>(e=>!0===e?d:!1===e?l:"")(e)}
`,b=o.default.span((({theme:e})=>({position:"absolute",left:e.spacing.medium,top:e.spacing.medium,display:"flex",alignItems:"center"})));exports.ControlText=u,exports.PlaceholderText=c,exports.StyledActionContainer=g,exports.StyledInputBox=m,exports.StyledLeftActionContainer=b,exports.StyledTextFieldContainer=p;
//# sourceMappingURL=styled-B7WTd4dR.js.map
